import { useLayoutEffect, useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function ScrollRestoration() {
  const { pathname } = useLocation(); // 지금 페이지 경로
  const navType = useNavigationType(); // 이동하는 방식
  const prevPathnameRef = useRef(pathname); // 이전 페이지 경로 저장
  const currentScrollRef = useRef(0); // 현재 스크롤 위치값 저장

  // 스크롤 위치를 실시간으로 추적
  useEffect(() => {
    // 사용자가 스크롤을 할 때마다 실행되는 함수
    const handleScroll = () => {
      currentScrollRef.current = window.scrollY; // 현재 스크롤값 저장
    };



    // 스크롤 이벤트만 등록
    window.addEventListener('scroll', handleScroll, { passive: true });

    // 컴포넌트가 사라지면 return을 타면서 중단시킴
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useLayoutEffect(() => {
    
    // 스크롤 복원 기능 끄기
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'; // 수동 모드
    }

    // 🚨 새로고침 시에는 맨 위로 이동 + 저장된 값 삭제
    if (!navType || navType === 'REPLACE') {
      
      // 현재 페이지의 저장된 스크롤 위치 삭제
      sessionStorage.removeItem(`scroll_${pathname}`);
      
      // 맨 위로 강제 이동
      window.scrollTo(0, 0);
      currentScrollRef.current = 0;
      
      prevPathnameRef.current = pathname;
      return;
    }

    if (navType === 'PUSH') {
      // SPA 페이지 이동 시에만 스크롤 위치 저장 (이것만으로 충분!)
      const prevPath = prevPathnameRef.current; // 이전 페이지 경로값
      if (prevPath && prevPath !== pathname) { // 다른 페이지로 이동했을 경우
        const scrollToSave = currentScrollRef.current; // 현재 스크롤값
        sessionStorage.setItem(`scroll_${prevPath}`, scrollToSave); // 세션 스토리지에 값을 저장함
      }
      
      // 새 페이지는 맨 위로
      window.scrollTo(0, 0);
      currentScrollRef.current = 0;
      
    } else if (navType === 'POP') {
      // 저장된 스크롤 위치값을 다시 가져옴
      const savedY = Number(sessionStorage.getItem(`scroll_${pathname}`)) || 0;
      
      if (savedY > 0) {
        const restore = () => {
          window.scrollTo(0, savedY); // 저장된 위치로 스크롤 이동
          currentScrollRef.current = savedY; // 바뀐 위치값을 업데이트함
        };
        
        // 여러 번 복원 시도 (데이터 로딩 고려)
        restore();
        setTimeout(restore, 100);
        setTimeout(restore, 300); 
        setTimeout(restore, 600);
        // setTimeout(restore, 1200);
      }
    }
    
    // 현재 경로를 다음번을 위해 저장
    prevPathnameRef.current = pathname;
    
  }, [pathname, navType]); 

  return null;
}